import Vue from 'vue';
import AlertSnackBar from '@/ui/molecules/AlertSnackBar.vue';

const AlertConstructor = Vue.extend(AlertSnackBar);

let instance;

function initInstance() {
  if (!instance) {
    instance = new AlertConstructor();
    instance.$mount(document.createElement('div'));
    document.body.appendChild(instance.$el);
  }
}

export default {
  fireAlert(message, options = {}) {
    initInstance();
    instance.addAlert(message, options);
  },
};
